const w = typeof window !== "undefined" ? window : void 0;
const isMyBusinessDomain = (hostname) => {
  return hostname === "mybusiness.telia.se" || hostname.endsWith(".mybusiness.telia.se");
};
const isTeliaAtWorkDomain = (hostname) => {
  return hostname === "telia-at-work.telia.se" || hostname.endsWith(".telia-at-work.telia.se");
};
const isUnderTestTelia = (hostname) => {
  return hostname.endsWith(".test.telia.se") || hostname.endsWith(".test.mybusiness.telia.se") || hostname.endsWith(".test.telia-at-work.telia.se");
};
const rule = (url) => {
  return {
    /** True if the URL is considered a dev/test environment (e.g. *.test.telia.se or window.ENVIRONMENT === "legacy-dev"). */
    isDev: isDev(url),
    /** True if the URL is a production environment (www.telia.se, telia.se, mybusiness.telia.se, telia-at-work.telia.se). */
    isProd: isProd(url),
    /** True if the URL targets the B2B segment — either via a B2B domain (mybusiness/telia-at-work) or a pathname starting with /foretag. */
    isB2B: isB2B(url),
    /** True if the URL does not target the B2B segment. Inverse of isB2B. */
    isB2C: isB2C(url),
    /** True if the URL is publicly accessible (not behind login). Inverse of isPrivate. */
    isPublic: isPublic(url),
    /** True if the URL requires authentication — B2B domains (mybusiness/telia-at-work) or paths under /mitt-telia, /privat/mitt-telia, /foretag/mybusiness, /foretag/telia-at-work. */
    isPrivate: isPrivate(url),
    /** Returns true if the pathname ends with any of the given segments. */
    pathEndsWith: (segments) => endsWith(segments, url),
    /** Returns true if the pathname starts with any of the given segments. */
    pathStartsWith: (segments) => startsWith(segments, url),
    /** Returns true if the pathname contains any of the given substrings. */
    pathIncludes: (segments) => includes(segments, url),
    /** Returns true if the pathname matches any of the given regular expressions. */
    pathMatches: (regexps) => matches(regexps, url),
    /** Returns true if the pathname is an exact string match with any of the given strings. */
    pathMatchesExact: (strings) => matchesExact(strings, url)
  };
};
const isDev = (url) => {
  const hostname = url.hostname;
  if (isUnderTestTelia(hostname)) {
    return true;
  }
  if (typeof w?.ENVIRONMENT !== "undefined" && w?.ENVIRONMENT === "legacy-dev") {
    return true;
  }
  if (isMyBusinessDomain(hostname) || isTeliaAtWorkDomain(hostname)) {
    return false;
  }
  if (hostname === "www.telia.se" || hostname === "telia.se") {
    return false;
  }
  return true;
};
const isProd = (url) => {
  const hostname = url.hostname;
  if (isUnderTestTelia(hostname)) {
    return false;
  }
  if (hostname === "www.telia.se" || hostname === "telia.se") {
    return true;
  }
  return isMyBusinessDomain(hostname) || isTeliaAtWorkDomain(hostname);
};
const isB2B = (url) => {
  const hostname = url.hostname;
  if (isMyBusinessDomain(hostname) || isTeliaAtWorkDomain(hostname)) {
    return true;
  }
  return url.pathname?.startsWith("/foretag");
};
const isB2C = (url) => !isB2B(url);
const isPrivate = (url) => {
  const hostname = url.hostname;
  if (isMyBusinessDomain(hostname) && !startsWith(["/foretag/bredband/"], url)) {
    return true;
  }
  if (isTeliaAtWorkDomain(hostname)) {
    return true;
  }
  return startsWith(
    ["/privat/mitt-telia", "/mitt-telia", "/foretag/mybusiness", "/foretag/telia-at-work"],
    url
  );
};
const isPublic = (url) => !isPrivate(url);
const startsWith = (segment, url) => segment.some((pathname) => url.pathname.startsWith(pathname));
const endsWith = (segment, url) => segment.some((pathname) => url.pathname.endsWith(pathname));
const includes = (segment, url) => segment.some((pathname) => url.pathname.includes(pathname));
const matches = (regexps, url) => regexps.some((pattern) => pattern.test(url.pathname));
const matchesExact = (strings, url) => strings.some((str) => str === url.pathname);

export { rule };
//# sourceMappingURL=b2x-url-segments.esm.js.map
